import _objectWithoutProperties from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data"];
export var createBlobEventFactory = function createBlobEventFactory(nativeBlobEventConstructor) {
  return function (type, blobEventInit) {
    // Bug #14: Safari does not yet support the BlobEvent.
    if (nativeBlobEventConstructor === null) {
      var data = blobEventInit.data,
        eventInit = _objectWithoutProperties(blobEventInit, _excluded);
      var fakeBlobEvent = new Event(type, eventInit);
      fakeBlobEvent.data = data;
      return fakeBlobEvent;
    }
    return new nativeBlobEventConstructor(type, blobEventInit);
  };
};